export enum CompanyDetailFormPropsEnum {
  IMAGE_ALT = 'Carbon one',
  PAGE_TITLE = 'Company details',
  BUTTON_LABEL_SUBMIT = 'Continue',
  UPDATE = 'Update',
  BUTTON_LABEL_BACK = 'Back',
}
export enum FileTypes {
  SVG = 'image/svg+xml',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
}

export enum ImageUploadProps {
  ERROR_MESSAGE_SIZE = 'Image must smaller than 2MB!',
  IMAGE_REQUIRED = 'Please select image',
  ERROR_MESSAGE_FORMAT = 'You can only upload JPG/PNG file!',
  ICON_ALT = 'camera-icon',
  NAME = 'avatar',
  LIST_TYPE = 'picture-card',
  ACTION_URL = 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
}
export enum ImageUploadStatus {
  COMPLETED = 'done',
  UPLOADING = 'uploading',
}
